import React from 'react'
import './new_organic_social_dashboard.css'
import { getImgSrc } from '../../../../helpers/getImgSrc'
import { IoArrowUp } from "react-icons/io5";
import { FiHeart } from "react-icons/fi";
import { BiComment } from "react-icons/bi";
import { IoShareSocialOutline } from "react-icons/io5";
import { HiOutlineBookmark } from "react-icons/hi2";
import { LuVideo } from "react-icons/lu";
import { AiOutlineEye } from "react-icons/ai";
import { IoMdLink } from "react-icons/io";
import { LuClock4 } from "react-icons/lu";

import { getSvgIcons } from '../../../../helpers/getReactIcons';



import LeadsBarChart from '../../../../components/client/dashboard/LeadsBarChart';
import OrganicPerformanceCard from '../../../../components/client/dashboard/new_organic_social_dashboard/organic_performance_card/OrganicPerformanceCard';
import MostEngagedPlatform from  "../../../../components/client/dashboard/new_organic_social_dashboard/most_engaged_platform/MostEngagedPlatform"






const NewOrganicSocialDashboard = ({
  facebook_organic_social,
  instagram_organic_social,
  linkedin_organic_social,
  top_performing_posts,
  most_engaged_platform
}) => {




  // values,labels,backgroundColors
//facebook
  const facebook_metrics=[
    // {
    //   heading:'Audience Growth',
    //   data:[
    //     {
    //       metric_name:'new followers',
    //       value:0,
    //       increment:''
    //     },
    //     {
    //       metric_name:'growth rate',
    //       value:'0%',
    //       increment:'0.8%'
    //     }
    //   ]
    // },
    {
      heading:'Video & Clicks Metrics',
    
      data:[
        {
          metric_name:'video views',
          metric_icon:<AiOutlineEye />,
          value:facebook_organic_social?.video_views?facebook_organic_social?.video_views:0,
          increment:''
        },
        {
          metric_name:'link  clicks',
          metric_icon:<IoMdLink />,
          value:facebook_organic_social?.clicks?facebook_organic_social?.clicks:0,
          increment:''
        },
        // {
        //   metric_name:'avg. watch time',
        //   metric_icon:getSvgIcons('clock',{color:''}),
        //   value:'0s',
        //   increment:''
        // },
        // {
        //   metric_name:'completion rate',
        //   metric_icon:'',
        //   value:'0%',
        //   increment:''
        // },
        // {
        //   metric_name:'click through rate',
        //   metric_icon:'',
        //   value:'0%',
        //   increment:'0%'
        // }
      ]
    }
  ]

  //instagram
  const instagram_metrics=[
    // {
    //   heading:'Audience Growth',
    //   data:[
    //     {
    //       metric_name:'new followers',
    //       value:0,
    //       increment:''
    //     },
    //     {
    //       metric_name:'growth rate',
    //       value:'0%',
    //       increment:'0.8%'
    //     }
    //   ]
    // },
    {
      heading:'Video & Clicks Metrics',
    
      data:[
        {
          metric_name:'video views',
          metric_icon:<AiOutlineEye />,
          value:instagram_organic_social?.video_views?instagram_organic_social?.video_views:0,
          increment:''
        },
        {
          metric_name:'link  clicks',
          metric_icon:<IoMdLink />,
          value:instagram_organic_social?.clicks?instagram_organic_social?.clicks:0,
          increment:''
        },
        // {
        //   metric_name:'avg. watch time',
        //   metric_icon:getSvgIcons('clock',{color:''}),
        //   value:'0s',
        //   increment:''
        // },
        // {
        //   metric_name:'completion rate',
        //   metric_icon:'',
        //   value:'0%',
        //   increment:''
        // },
        // {
        //   metric_name:'click through rate',
        //   metric_icon:'',
        //   value:'0%',
        //   increment:'0%'
        // }
      ]
    }
  ]

  //linkedin
  const linkedin_metrics=[
    // {
    //   heading:'Audience Growth',
    //   data:[
    //     {
    //       metric_name:'new followers',
    //       value:0,
    //       increment:''
    //     },
    //     {
    //       metric_name:'growth rate',
    //       value:'0%',
    //       increment:'0%'
    //     }
    //   ]
    // },
    {
      heading:'Video & Clicks Metrics',
    
      data:[
        {
          metric_name:'video views',
          metric_icon:<AiOutlineEye />,
          value:linkedin_organic_social?.video_views?linkedin_organic_social?.video_views:0,
          increment:''
        },
        {
          metric_name:'link  clicks',
          metric_icon:<IoMdLink />,
          value:linkedin_organic_social?.clicks?linkedin_organic_social?.clicks:0,
          increment:''
        },
        // {
        //   metric_name:'avg. watch time',
        //   metric_icon:getSvgIcons('clock',{color:''}),
        //   value:'0s',
        //   increment:''
        // },
        // {
        //   metric_name:'completion rate',
        //   metric_icon:'',
        //   value:'0%',
        //   increment:''
        // },
        // {
        //   metric_name:'click through rate',
        //   metric_icon:'',
        //   value:'0%',
        //   increment:'0%'
        // }
      ]
    }
  ]


  const facebook_reach_impressions_metrics=[  
     {
    metric_name:'Engagement Rate (%)',
    value:(facebook_organic_social?.total_engagement_rate?facebook_organic_social?.total_engagement_rate:0)+'%' ,
    increment:'0%'
  },
  // {
  //   metric_name:'total reach',
  //   value:'0',
  //   increment:'0%'
  // },

 {
    metric_name:'total impressions',
    value:facebook_organic_social?.impressions,
    increment:'0%'
  }]

  const instagram_reach_impressions_metrics=[ 
  // {
  //   metric_name:'total reach',
  //   value:'0',
  //   increment:'0%'
  // },
  {
    metric_name:'Engagement Rate (%)',
    value:(instagram_organic_social?.total_engagement_rate?instagram_organic_social?.total_engagement_rate:0)+'%',
    increment:'0%'
  },
  {
    metric_name:'total reach',
    value:instagram_organic_social?.reach,
    increment:'0%'
  },
  // {
  //   metric_name:'non-followed reached',
  //   value:'0',
  //   increment:'0%'
  // }
]

const linkedin_reach_impressions_metrics=[ 
//   {
//   metric_name:'total reach',
//   value:'0',
//   increment:'0%'
// },
{
  metric_name:'Engagement Rate (%)',
  value:(linkedin_organic_social?.total_engagement_rate?linkedin_organic_social?.total_engagement_rate:0)+'%',
  increment:'0%'
},
{
  metric_name:'total impressions',
  value:linkedin_organic_social?.impressions,
  increment:'0%'
},
// {
//   metric_name:'non-followed reached',
//   value:'0',
//   increment:'0%'
// }
]

const facebook_engagement_overview_metrics={
  total_engagement_rate:{ value:(facebook_organic_social?.total_engagement_rate?facebook_organic_social?.total_engagement_rate:0)+'%' , icon:''},
  reactions: { value:facebook_organic_social?.like ? facebook_organic_social?.like:0 , icon:getSvgIcons('heart',{color:'#f37373'})},
  comments:{ value:facebook_organic_social?.comments ? facebook_organic_social?.comments:0  , icon:getSvgIcons('comment',{color:'#6ba1f8'})},
  saves:{ value:facebook_organic_social?.saves ? facebook_organic_social?.saves:0, icon:getSvgIcons('bookmark',{color:'#ad5ff7'})},
  shares:{ value:facebook_organic_social?.shares ? facebook_organic_social?.shares:0, icon:getSvgIcons('share',{color:'#2cc765'})}
}
  
const instagram_engagement_overview_metrics={
  total_engagement_rate:{ value:(instagram_organic_social?.total_engagement_rate?instagram_organic_social?.total_engagement_rate:0)+'%', icon:''},
  reactions: { value:instagram_organic_social?.like?instagram_organic_social?.like:0 , icon:getSvgIcons('heart',{color:'#f37373'})},
  comments:{ value:instagram_organic_social?.comments?instagram_organic_social?.comments:0 , icon:getSvgIcons('comment',{color:'#6ba1f8'})},
  saves:{ value:instagram_organic_social?.saves?instagram_organic_social?.saves:0 , icon:getSvgIcons('bookmark',{color:'#ad5ff7'})},
  shares:{ value:instagram_organic_social?.shares?instagram_organic_social?.shares:0 , icon:getSvgIcons('share',{color:'#2cc765'})}
}

const linkedin_engagement_overview_metrics={
  total_engagement_rate:{ value:(linkedin_organic_social?.total_engagement_rate?linkedin_organic_social?.total_engagement_rate:0)+'%', icon:''},
  reactions: { value:linkedin_organic_social?.like ? linkedin_organic_social?.like :0, icon:getSvgIcons('heart',{color:'#6ba1f8'})},
  comments:{ value:linkedin_organic_social?.comments ? linkedin_organic_social?.comments :0 , icon:getSvgIcons('comment',{color:'#6ba1f8'})},
  saves:{ value:linkedin_organic_social?.saves ? linkedin_organic_social?.saves :0 , icon:getSvgIcons('bookmark',{color:'#6ba1f8'})},
  shares:{ value:linkedin_organic_social?.shares ? linkedin_organic_social?.shares :0 , icon:getSvgIcons('share',{color:'#6ba1f8'})}
}

let facebook_top_performing_post=[];
let instagram_top_performing_post=[];
let linkedin_top_performing_post=[];

const shortenPostTitle=(post_title)=>{
   let message=post_title?.split(' ')
  if(message?.length>30)
  {
    return message.slice(0,12)+"..."
  }
  return message

}
if(top_performing_posts?.facebook?.length>0)
{
  facebook_top_performing_post=top_performing_posts?.facebook?.map((post)=>{
        
        if(post?.message!="")
        {
          post={...post,message:shortenPostTitle(post?.message)}
        }
       if(post?.media_type==="video")
       {
        return post={...post,post_icon:getSvgIcons('video',{color:'#8eb8ff'})}
       }
       if(post?.media_type==="link")
        {
          return post={...post,post_icon:getSvgIcons('link',{color:'#f48282'})}
        }
        if(post?.media_type==="photo")
          {
            return post={...post,post_icon:getSvgIcons('photo',{color:'#f48282'})}
          }
        if(post?.media_type==="")
        {
          return  post={...post,post_icon:getSvgIcons('document',{color:'#2cc866'})}
        }
        return {...post,post_icon:getSvgIcons('document',{color:'#709cf4'})};
  })
}
if(top_performing_posts?.instagram?.length>0)
  {
    instagram_top_performing_post=top_performing_posts?.instagram?.map((post)=>{
      if(post?.message!="")
        {
          post={...post,message:shortenPostTitle(post?.message)}
        }
         if(post?.media_type==="video")
         {
          return post={...post,post_icon:getSvgIcons('video',{color:'#f285bb'})}
         }
         if(post?.media_type==="link")
          {
            return post={...post,post_icon:getSvgIcons('link',{color:'#f48282'})}
          }
          if(post?.media_type==="document")
            {
            return post={...post,post_icon:getSvgIcons('document',{color:'#f97e28'})}
            }
          if(post?.media_type==="")
          {
            return  post={...post,post_icon:getSvgIcons('document',{color:'#f97e28'})}
          }
          return {...post,post_icon:getSvgIcons('document',{color:'#f97e28'})};
    })
  }
  if(top_performing_posts?.linkedin?.length>0)
    {
      linkedin_top_performing_post=top_performing_posts?.linkedin?.map((post)=>{
        if(post?.message!="")
          {
            post={...post,message:shortenPostTitle(post?.message),engagement:post?.engagement.toFixed(2)}
          }
           if(post?.media_type==="video")
           {
            return  post={...post,post_icon:getSvgIcons('video',{color:'#2e6aec'})}
           }
           if(post?.media_type==="link")
            {
              return post={...post,post_icon:getSvgIcons('link',{color:'#2e6aec'})}
            }
            if(post?.media_type==="document")
              {
                return post={...post,post_icon:getSvgIcons('document',{color:'#2e6aec'})}
              }
            if(post?.media_type==="")
            {
              return post={...post,post_icon:getSvgIcons('document',{color:'#2e6aec'})}
            }
            return {...post,post_icon:getSvgIcons('document',{color:'#2e6aec'})};
      })
    }

const facebook_content_performance_metrics={
  graph_data:{

  },
  // top_performing_posts:[
  //   {
  //     post_name:'Product announcement video',
  //     post_icon:getSvgIcons('video',{color:'#8eb8ff'}),
  //     engagement_value:0,
  //     date:new Date().toLocaleDateString()
  //   },
  //   {
  //     post_name:'Team celebration photo',
  //     post_icon:getSvgIcons('document',{color:'#2cc866'}),
  //     engagement_value:0,
  //     date:new Date().toLocaleDateString()
  //   },
  //   {
  //     post_name:'Industry Report Link',
  //     post_icon:getSvgIcons('link',{color:'#f48282'}),
  //     engagement_value:0,
  //     date:new Date().toLocaleDateString()
  //   }
  // ]
  top_performing_posts:facebook_top_performing_post
}

const instagram_content_performance_metrics={
  graph_data:{

  },
  // top_performing_posts:[
  //   {
  //     post_name:'Product fetaures reel',
  //     post_icon:getSvgIcons('video',{color:'#f285bb'}),
  //     engagement_value:0,
  //     date:new Date().toLocaleDateString()
  //   },
  //   {
  //     post_name:'Design process carousel',
  //     post_icon:getSvgIcons('document',{color:'#f97e28'}),
  //     engagement_value:0,
  //     date:new Date().toLocaleDateString()
  //   },
  //   {
  //     post_name:'Customer spotlight',
  //     post_icon:getSvgIcons('link',{color:'#ae61f8'}),
  //     engagement_value:0,
  //     date:new Date().toLocaleDateString()
  //   }
  // ],
  top_performing_posts:instagram_top_performing_post


}

const linkedin_content_performance_metrics={
  graph_data:{

  },
  // top_performing_posts:[
  //   {
  //     post_name:'Product fetaures reel',
  //     post_icon:getSvgIcons('video',{color:'#2e6aec'}),
  //     engagement_value:0,
  //     date:new Date().toLocaleDateString()
  //   },
  //   {
  //     post_name:'Design process carousel',
  //     post_icon:getSvgIcons('document',{color:'#2e6aec'}),
  //     engagement_value:0,
  //     date:new Date().toLocaleDateString()
  //   },
  //   {
  //     post_name:'Customer spotlight',
  //     post_icon:getSvgIcons('link',{color:'#2e6aec'}),
  //     engagement_value:0,
  //     date:new Date().toLocaleDateString()
  //   }
  // ],
  top_performing_posts:linkedin_top_performing_post
}








  return (
    <div className='organic_social_main'>
      <section className='facebook_organic_performance_section'>
        <OrganicPerformanceCard 
         heading={'Facebook Organic Performance'}
         heading_icon="facebook"
         metrics={facebook_metrics}
         card_styles={
          {
            card_border_color:'#4267b2',
            card_background_color_class:'facebook_background'
          }
         }
         reach_impressions_metrics={facebook_reach_impressions_metrics}
         engagement_overview_metrics={facebook_engagement_overview_metrics}
         content_performance_metrics={facebook_content_performance_metrics}
         bar_graph_data={
          {
            backgroundColor:'#4267b2',
            borderColor:'#4267b2'
          }
         }
        
        />  
      </section>
      <section className='instagram_organic_performance_section'>
        <OrganicPerformanceCard 
          heading={'Instagram Organic Performance'}
          heading_icon="instagram"
          metrics={facebook_metrics}
          reach_impressions_metrics={instagram_reach_impressions_metrics}
          engagement_overview_metrics={instagram_engagement_overview_metrics}
          content_performance_metrics={instagram_content_performance_metrics}
          card_styles={
            {
              card_border_color:'#c13584',
              card_background_color_class:'instagram_background'
            }
           }
           bar_graph_data={
            {
              backgroundColor:'#c13584',
              borderColor:'#c13584'
            }
           }
        
        />
      </section>
      <section className='linkedin_organic_performance_section'>
      <OrganicPerformanceCard 
          heading={'LinkedIn Organic Performance'}
          heading_icon="linkedin"
          metrics={linkedin_metrics}
          reach_impressions_metrics={linkedin_reach_impressions_metrics}
          engagement_overview_metrics={linkedin_engagement_overview_metrics}
          content_performance_metrics={linkedin_content_performance_metrics}
          card_styles={
            {
              card_border_color:'#4267b2',
              card_background_color_class:'linkedin_background'
            }
           }
           bar_graph_data={
            {
              backgroundColor:'#4267b2',
              borderColor:'#4267b2'
            }
           }
        
        />

      </section>
      <section className='most_engaged_platform_section'>
        <MostEngagedPlatform  
         heading="Most Engaged Platform"
        heading_icon="reports"
        most_engaged_platform={most_engaged_platform}
        
        />

      </section>

    </div>
  )
}

export default NewOrganicSocialDashboard